import Script from 'next/script';
import { CustomAppEvents } from '@packages/shared/core/common/entities';

type ClarityScriptProps = {
  clarityId: string;
};

export function ClarityScript({ clarityId }: ClarityScriptProps) {
  if (!clarityId) {
    return null;
  }

  return (
    <Script
      key="clarityHeatmap"
      id="clarityHeatmap"
      strategy="afterInteractive"
      onReady={() => {
        const event = new Event(CustomAppEvents.CLARITY_LOADED);
        document.dispatchEvent(event);
      }}
      dangerouslySetInnerHTML={{
        __html: `(function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          t.id="clarityScript";y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityId}");`,
      }}
    />
  );
}
